<template>
    <div class="flex items-center justify-between gap-6 border-b border-gray-200 pb-5 mb-5">
        <label class="flex-shrink-0 font-medium">{{ __('admin::labels.select_feed') }}:</label>
        <Select
            :options="selectableFeedOptions"
            :modelValue="selectedFeedId || ''"
            @update:modelValue="$emit('select', $event !== '' ? parseInt($event) : null)"
            :allow-empty="true"
            :placeholder="__('admin::project.root_project')"
        />
    </div>
</template>

<script>
import Select from "@/Components/Select";
export default {
    components: {
        Select,
    },
    props: {
        project: Object,
        selectedFeedId: [Number, null],
    },
    computed: {
        selectableFeedOptions() {
            const options = {};

            for (let property in this.project.feeds) {
                const feed = this.project.feeds[property];
                options[feed.id] = feed.name;
            }

            return options;
        },
    },
}
</script>
